import GameApp from "./components/GameApp";
import "./index.css";
import "animate.css";
import { GameProvider } from "./context/GameContext";

function WordsTrivia({ id }) {
  return (
    <GameProvider id={id}>
      <div className="App">
        <GameApp />
      </div>
    </GameProvider>
  );
}

export default WordsTrivia;
